var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "dataset-view" },
    [
      _c(
        "div",
        { attrs: { id: "savedSearchPopup" } },
        [
          _c("saved-search-popup", {
            attrs: {
              "is-adding": _vm.isSavedSearchAdding,
              "is-visible": _vm.isSavedSearchVisible,
              "active-tab": _vm.activeSavedSearchTab,
              "dial-back-hours": _vm.DIAL_BACK_HOURS,
              favorites: _vm.favorites,
              history: _vm.history,
            },
            on: {
              "popup-close": _vm.popupClose,
              "favorite-added": _vm.addNewFavorite,
              "delete-favorite": _vm.deleteFavorite,
              "delete-history": _vm.deleteHistory,
              "enable-favorite": _vm.enableFavorite,
              "enable-history": _vm.enableHistory,
              "favorite-renamed": _vm.favoriteRenamed,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("section", { staticClass: "dataset-header" }, [
        _c("div", { staticClass: "vy-row" }, [
          _c("div", { staticClass: "col-md-4 col-xs-12" }, [
            _c("h1", { staticClass: "capture-view-title" }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-5 col-xs-12" },
            [
              _vm.hasDateRangePicker
                ? _c("dial-back-component", {
                    attrs: { "date-range-model": _vm.dateRangeModel },
                    on: {
                      "dial-back-current-range":
                        _vm.dialBackCurrentRangeHandler,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.hasExtendedDateRangePicker
                ? _c("date-selection-popup", {
                    attrs: { "date-text": _vm.currentDateText },
                    on: { "range-selected": _vm.dialBackCurrentRangeHandler },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3 col-xs-12" }, [
            _c(
              "div",
              { staticClass: "buttonContainer pull-right" },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn assurance-header-button left-most assurance-capture-button vyopta-btn-light-blue page-capture",
                    attrs: {
                      "data-toggle": "tooltip",
                      "data-placement": "bottom",
                      title: "Capture page",
                    },
                    on: { click: _vm.showCaptureModal },
                  },
                  [_c("i", { staticClass: "far fa-camera page-camera" })]
                ),
                _vm._v(" "),
                _vm.hasCsvActions
                  ? _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "button",
                                    _vm._g(
                                      {
                                        staticClass:
                                          "btn assurance-header-button upload-download-icon",
                                        attrs: { text: "" },
                                        on: {
                                          click: function ($event) {
                                            _vm.showUploadDownloadModal = true
                                          },
                                        },
                                      },
                                      on
                                    ),
                                    [
                                      _c("i", {
                                        staticClass: "far fa-file-spreadsheet",
                                      }),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          738843133
                        ),
                      },
                      [_vm._v(" "), _c("span", [_vm._v("CSV Actions")])]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn assurance-header-button",
                    attrs: {
                      "data-toggle": "tooltip",
                      "data-placement": "bottom",
                      title: "View recent search history",
                    },
                    on: { click: _vm.openHistory },
                  },
                  [_c("i", { staticClass: "far fa-history" })]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn assurance-header-button",
                    attrs: {
                      "data-toggle": "tooltip",
                      "data-placement": "bottom",
                      title: "View saved searches",
                    },
                    on: { click: _vm.openFavorites },
                  },
                  [_c("i", { staticClass: "far fa-book-heart" })]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn assurance-header-button right-most",
                    class: { disabled: !_vm.filterModel.getActiveFilters() },
                    attrs: {
                      "data-toggle": "tooltip",
                      "data-placement": "bottom",
                      title: "Save search",
                    },
                    on: { click: _vm.addFavorite },
                  },
                  [_c("i", { staticClass: "far fa-bookmark" })]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.hasDashboard
        ? _c(
            "section",
            { staticClass: "filter-expression-wrapper" },
            [
              _vm.filterColumns.length > 0
                ? _c("filter-expression", {
                    staticClass: "header-filter-expression",
                    attrs: {
                      columns: _vm.filterColumns,
                      "dataset-name": _vm.datasetName,
                      "filter-groups":
                        _vm.filterModel.getActiveFilters().filterGroups,
                      mode: "simple",
                      operator: _vm.filterModel.getActiveFilters().operator,
                    },
                    on: {
                      "filters-updated": _vm.updateFilterGroups,
                      "operator-changed": _vm.updateOperator,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasDashboard
        ? _c(
            "section",
            { staticClass: "dashboardSection" },
            [
              _c("DashboardContainer", {
                attrs: {
                  "app-id": _vm.appId,
                  "view-id": _vm.viewId,
                  "dataset-name": _vm.datasetName,
                  "date-range": _vm.dateRangeModel.getCurrentRange(),
                  "is-live-mode": _vm.isLiveMode,
                  "filter-model": _vm.filterModel,
                  "filter-ready-signal": _vm.filterReadySignal,
                  "nested-field-separator": _vm.nestedFieldSeparator,
                  panels: _vm.datasetMetadata.panels,
                  "column-metadata": _vm.datasetMetadata.columns,
                },
                on: { "filters-updated": _vm.updateFilterGroups },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "section",
        {
          staticClass: "dataset-view-content styleScroll",
          class: { "drawer-open": _vm.drawerOpen },
          attrs: { id: "datasetView" },
        },
        [
          _c("data-table", {
            key: _vm.datasetName,
            attrs: {
              "app-id": _vm.appId,
              "view-id": _vm.viewId,
              "dataset-name": _vm.datasetName,
              "is-live-mode": _vm.isLiveMode,
              "disable-row-selection": true,
              "date-range": _vm.dateRangeModel.getCurrentRange(),
              "filter-model": _vm.filterModel,
              "filter-ready-signal": _vm.filterReadySignal,
              "hide-filter": _vm.hasDashboard,
              "nested-field-separator": _vm.nestedFieldSeparator,
              "auto-reload-callback": _vm.autoReloadCallback,
              "data-loaded-callback": _vm.dataLoadedCallback,
              "row-click-callback": _vm.rowClickCallback,
              "watch-org-context": _vm.watchOrgContext,
            },
            on: { "edit-metadata": _vm.editRow },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.bottomDrawerDatasetName
        ? _c("div", { attrs: { id: "bottomDrawerDataset" } }, [
            _c(
              "div",
              {
                staticClass: "dataset-view-bottom-drawer",
                class: {
                  "show-drawer": _vm.drawerOpen,
                  "drawer-expanded": _vm.drawerExpanded,
                },
              },
              [
                _c("div", { staticClass: "bottom-drawer-header" }, [
                  _c("div", { staticClass: "bottom-drawer-border" }),
                  _vm._v(" "),
                  _c("span", {
                    directives: [
                      {
                        name: "dompurify-html",
                        rawName: "v-dompurify-html",
                        value: _vm.bottomDrawerTitle,
                        expression: "bottomDrawerTitle",
                      },
                    ],
                    staticClass: "bottom-drawer-title",
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "bottom-drawer-icons" }, [
                    !_vm.drawerExpanded
                      ? _c("i", {
                          staticClass: "fal fa-square-chevron-up",
                          attrs: { title: "Expand Participants" },
                          on: {
                            click: function ($event) {
                              _vm.drawerExpanded = !_vm.drawerExpanded
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.drawerExpanded
                      ? _c("i", {
                          staticClass: "fal fa-square-chevron-down",
                          attrs: { title: "Collapse Participants" },
                          on: {
                            click: function ($event) {
                              _vm.drawerExpanded = !_vm.drawerExpanded
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "fal fa-times-circle",
                      attrs: { title: "Close Participants" },
                      on: { click: _vm.closeBottomDrawer },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "bottom-drawer-table-container" },
                  [
                    _c("data-table", {
                      key: _vm.bottomDrawerDatasetName,
                      attrs: {
                        id: "bottom-drawer-table",
                        "app-id": _vm.appId,
                        "view-id": _vm.viewId,
                        "dataset-name": _vm.bottomDrawerDatasetName,
                        "date-range": _vm.dateRangeModel.getCurrentRange(),
                        "disable-row-selection": true,
                        "hide-edit": _vm.hideBottomDrawerEdit,
                        "hide-filter": true,
                        "local-data-mode": true,
                        "local-table-data": _vm.bottomDrawerTableData,
                        "nested-field-separator": _vm.nestedFieldSeparator,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.datasetName
        ? _c("EditModal", {
            attrs: {
              columns: _vm.editColumns,
              editingRow: _vm.editingRow,
              objectName: _vm.title.slice(0, -1),
              primaryKey: _vm.getPrimaryKey,
              saveService: _vm.getActiveService,
              showEditModal: _vm.showRowEditModal,
            },
            on: { finished: _vm.editFinished },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("CsvActionsModal", {
        attrs: {
          "show-upload-download-modal": _vm.showUploadDownloadModal,
          "dataset-name": _vm.datasetName,
        },
        on: {
          close: function ($event) {
            _vm.showUploadDownloadModal = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }